/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { useLanguage } from '@/providers/LanguageProvider';
import { IPrompt } from 'types/prompt';

import { NotFoundMessage } from '../not-found';
import Loader from '../spinner/loader';
import { PromptCard } from './prompt-card';

interface PromptsTraceIdSearchTabProps {
  data?: IPrompt[];
  loading?: boolean;
}

const PromptsTraceIdSearchTab = ({
  data,
  loading,
}: PromptsTraceIdSearchTabProps) => {
  const { messages } = useLanguage();
  const langData = messages?.PromptsListing;
  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader
          title={langData?.getting_prompts}
          description={messages?.General.please_wait}
        />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <NotFoundMessage
        title={langData?.no_prompts_found}
        outerDivClassName="h-[814px] my-0"
      />
    );
  }

  return (
    <div className="flex flex-col gap-3 p-4">
      {data.map((prompt) => (
        <PromptCard key={prompt.trace_id} item={prompt} />
      ))}
    </div>
  );
};

export default PromptsTraceIdSearchTab;
